import { EmailTemplates } from "@/common/api.service"
import { FETCH_EMAIL_TEMPLATES, FETCH_EMAIL_TYPES, FETCH_MAIL_PLACEHOLDERS, FETCH_INDIVIDUAL_MAIL_TEMPLATE, SEND_TEST_MAIL, ADD_CUSTOM_MAIL_TEMPLATE, UPDATE_CUSTOM_MAIL_TEMPLATE,RESET_STATE, DELETE_EMAIL_TEMPLATE } from "./actions.type"
import { SET_EMAIL_TEMPLATES, SET_EMAIL_TYPES, SET_MAIL_PLACEHOLDERS, SET_INDIVIDUAL_TEMPLATE, SET_ERROR_TEMPLATE,STATE_RESET } from "./mutations.type"

const initialState = () => {
    return {
        emailtemplates:[],
        mailtypes: [],
        mailplaceholders:[],
        individualtemplate: [],
        templateerrors: null,
    }
}

let state = initialState()

const getters = {
    emailtemplates(state){
        return state.emailtemplates
    },
    mailtypes(state) {
        return state.mailtypes
    },
    mailplaceholders(state) {
        return state.mailplaceholders
    },
    individualtemplate(state) {
        return state.individualtemplate
    }
}

const actions = {
    async [FETCH_EMAIL_TEMPLATES](context, slug) {
        const { data } = await EmailTemplates.get(''+slug)
        context.commit(SET_EMAIL_TEMPLATES, data.data)
        return data;
    },
    async [FETCH_EMAIL_TYPES](context, slug) {
        const { data } = await EmailTemplates.get('mail-types/'+slug)
        context.commit(SET_EMAIL_TYPES, data.data)
        return data;
    },
    async [FETCH_MAIL_PLACEHOLDERS](context, slug) {
        const { data } = await EmailTemplates.get(slug)
        context.commit(SET_MAIL_PLACEHOLDERS, data.data)
        return data;
    },
    async [FETCH_INDIVIDUAL_MAIL_TEMPLATE](context, slug) {
        const { data } = await EmailTemplates.get(slug)
        context.commit(SET_INDIVIDUAL_TEMPLATE, data.data)
        return data;
    },  
    async [SEND_TEST_MAIL](context, payload) {
        return await EmailTemplates.test(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_TEMPLATE, error.response.data.errors)
        });
    },  
    async [ADD_CUSTOM_MAIL_TEMPLATE](context, payload) {
        return await EmailTemplates.create(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_TEMPLATE, error.response.data.errors)
        });
    },     
    async [UPDATE_CUSTOM_MAIL_TEMPLATE](context, payload) {
        return await EmailTemplates.update(payload, payload.id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_TEMPLATE, error.response.data.errors)
        });
    },  
    async [DELETE_EMAIL_TEMPLATE] (context, id) {
        return await EmailTemplates.delete(id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_TEMPLATE, error.response.data.errors)
        });
    },    
    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {
    [SET_EMAIL_TEMPLATES](state, templates) {
        state.emailtemplates = templates
    }, 
    [SET_EMAIL_TYPES](state, mailtypes) {
        state.mailtypes = mailtypes
    }, 
    [SET_MAIL_PLACEHOLDERS](state, placeholders) {
        let constructedPlaceholders = []
        placeholders.forEach(element => 
            constructedPlaceholders.push('{{'+element+'}}')
        );
        state.mailplaceholders = constructedPlaceholders;
    },
    
    [SET_ERROR_TEMPLATE](state, error) {
        state.templateerrors = error
    },      
    [SET_INDIVIDUAL_TEMPLATE](state, individualtemplate) {
        state.individualtemplate = individualtemplate
    },    
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    } 
};

export default {
    state,
    getters,
    actions,
    mutations
};